export default __webpack_public_path__ + "static/media/bnb.3495eb04.png";